export const NAME = 'Tutorial'; // the name of the app
export const CONTRACT_ADDRESS = 'KT1Rv5Nvc4A2e4hTHi34QhChYFdJ2aBjAp7P';
export const RPC_URL = 'https://granadanet.smartpy.io'; // network rpc url
export const NETWORK = 'granadanet';
